// Libraries
import { useEffect, useRef } from 'react';

const useSound = (
    src: string,
    volume: number = 1,
    playbackRate: number = 1,
) => {
    const audio = useRef(new Audio(src));

    useEffect(() => {
        audio.current.volume = volume;
    }, [volume]);

    useEffect(() => {
        audio.current.playbackRate = playbackRate;
    }, [playbackRate]);

    return audio.current;
};

export default useSound;
